import { S3Client } from '@aws-sdk/client-s3';
import { DynamoDBClient } from '@aws-sdk/client-dynamodb';
import { DynamoDBDocumentClient } from '@aws-sdk/lib-dynamodb';
import { awsCredentials } from './credentials';
import { config } from './config';

let s3: S3Client | null = null;
let ddb: DynamoDBDocumentClient | null = null;

export function getS3(): S3Client {
  if (!s3) {
    s3 = new S3Client({
      region: config.awsRegion,
      credentials: awsCredentials,
      // SDK versions from late 2024 onward default to opportunistically adding a CRC32 checksum
      // to every request (`requestChecksumCalculation: 'WHEN_SUPPORTED'`). For multipart uploads
      // via `@aws-sdk/lib-storage`'s `Upload` in the browser, this causes `CreateMultipartUpload`
      // to request a checksum that `CompleteMultipartUpload` then fails to supply per-part —
      // "InvalidRequest: ... missing for part 1". Revert to the pre-change default: only add a
      // checksum when the operation actually requires one.
      requestChecksumCalculation: 'WHEN_REQUIRED',
      responseChecksumValidation: 'WHEN_REQUIRED',
    });
  }
  return s3;
}

export function getDdb(): DynamoDBDocumentClient {
  if (!ddb) {
    ddb = DynamoDBDocumentClient.from(
      new DynamoDBClient({ region: config.awsRegion, credentials: awsCredentials }),
      { marshallOptions: { removeUndefinedValues: true } },
    );
  }
  return ddb;
}
